module.exports = __webpack_public_path__ + "img/login-image.6fd7d897.png";